

<template>
<App >
   <AppMask class="flex-wrap flex-center" style="background:var(--bg2);border-left:1px solid var(--border);overflow:hidden;z-index:1000;color:var(--subtext2);transition:all 0.3s ease-out" v-if="loading" :style="ready?'':'top:120%;'">
      <div class="flex-col">
      <h2 style="font-size:40px">会议室预约 - 后台管理</h2>
      <div class="flex-wrap" style="margin-top:10px">
      <BaseIcon icon="nbgz" color="var(--subtext2)" size="40" />
      <BaseLoading style="margin:0" />
      <BaseIcon icon="huiyi" color="var(--subtext2)" size="40" />
      </div>

      </div>
    </AppMask>
    <AppMask class="flex-wrap flex-center" style="background:var(--bg1);border-left:1px solid var(--border);color:#fff;transition:all 0.3s ease-out;bottom:50%;" v-if="loading" :style="ready?'':'bottom:120%'">
      <div>
      </div>
    </AppMask>

   <AppBar>
      <div class="flex-wrap">
        <AppTitle icon="huiyi" name="会议室预约 - 后台管理" />
      </div>

      <div class="flex-wrap split5">

        <AppAvatar />
      </div>
    </AppBar>


    <AppClient class="flex-wrap flex-line align-stretch">
      <div style="width:160px;flex-shrink:0;height:100%;position:relative;overflow:hidden;">
        <div class="flex-wrap flex-center" style="border-bottom:1px solid var(--border)">
          <Input clearable search style="margin:5px" placeholder="搜索日期" v-model="search_date" />
        </div>
        <BaseMenu :menus="filteredDays" style="width:200px;height:cal(100% - 60px) !important" :actived="selected.key" @on-click="handleSelect"/>
      </div>
      <div style="background:var(--bg3);flex-grow:1;padding:20px;">
        <div style="height:40px;padding-bottom:20px">
          <Input search style="width:200px;" clearable v-model="search_content" placeholder="搜索会议名称" />
          <Button @click="handleMigrate" style="margin-left:10px">同步数据</Button>
        </div>
        <template v-if="selected && selected.key">
        <Row  :gutter="10" style="border-bottom:1px solid var(--border);margin-top:20px;">
          <Col :span="4"> <div style="padding:10px">时间</div></Col>
        <Col :span="5" v-for="(r) in rooms" :key="r">
           <div style="padding:10px">{{r}}</div>
        </Col>
        </Row>
         <Row  :gutter="10">
          <Col :span="4">  <div class="flex-col align-center flex-center" style="height:80px;padding:5px;background:var(--bg2)">上午</div></Col>
        <Col :span="5" v-for="(r,i) in rooms" :key="r">
           <div class="flex-col align-start flex-center" style="height:80px;padding:5px;background:var(--bg2)">

            <BaseNameBoard :uid="selected.durations && selected.durations[0] && selected.durations[0][i]?selected.durations[0][i].created_by:null" />
             <div style="padding-left:30px">{{selected.durations && selected.durations[0] && selected.durations[0][i]?selected.durations[0][i].name:''}}</div></div>
        </Col>
        </Row>
        <Row :gutter="10" style="margin-top:10px">
          <Col :span="4">  <div class="flex-col align-center flex-center" style="height:80px;padding:5px;background:var(--bg2)">下午</div></Col>
        <Col :span="5" v-for="(r,i) in rooms" :key="r">
           <div class="flex-col align-start  flex-center" style="height:80px;padding:5px;background:var(--bg2)"><BaseNameBoard :uid="selected.durations && selected.durations[1] && selected.durations[1][i]?selected.durations[1][i].created_by:null" />
            <div style="padding-left:30px">{{selected.durations && selected.durations[1] && selected.durations[1][i]?selected.durations[1][i].name:''}}</div></div>
           </Col>
        </Row>
        </template>
      </div>
    </AppClient>

  </App>
</template>

<script>
import responsableMixin from '@/mixins/responsable';
import {mapGetters} from 'vuex';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppTitle from '@/components/app/title';
import AppMask from '@/components/app/mask';
import TaskLeft from '@/components/task/editor/left';
import VerticleMenu from '@/components/app/vmenu';
import AppAvatar from '@/components/app/avatar';
import AppClient from '@/components/app/client';
import IconButton from '@/components/app/IconButton';
import moment from 'moment';
export default {
  components: {App, AppBar, AppMask, TaskLeft, AppClient, AppAvatar, IconButton, AppTitle, VerticleMenu},
  data() {
    return {
      loading: false,
      showMenu: true,
      view: 'task',
      search_date: '',
      search_content: '',
      ready: true,
      items: [],
      res: {},
      task: {
        name: '新建表单',
      },
      selected: {},
      showHelper: true,
    };
  },
  mixins: [responsableMixin],
  watch: {
    $route: {
      handler(v) {
        // if(v && !v.includes('new'))
        //   return //load
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.ready = true;
    this.getData();
    setTimeout(()=>{
      this.ready = false;
    }, 1000);
  },
  activated() {
    this.$nextTick((e)=>{
      this.calcLayout();
    });
  },
  computed: {
    ...mapGetters('mat', ['level']),
    rooms() {
      return ['14楼大会议室', '14楼小会议室', '16楼会议室', '14楼餐厅'];
    },
    durations() {
      return ['上午', '下午'];
    },
    filteredDays() {
      return this.items.filter((v)=>{
        if (this.search_content) {
          let empty = true;
          for (let i=0; i<2; i++) {
            if (!v.durations || !v.durations[i]) {
              continue;
            }

            for (let j=0; j<4; j++) {
              if (v.durations[i][j] && v.durations[i][j].name &&　v.durations[i][j].name.includes(this.search_content)) {
                empty = false;
              }
            }
          }
          if (empty) {
            return false;
          }
          return true;
        } else if (this.search_date && !v.key.includes(this.search_date)) {
          return false;
        } else {
          return true;
        }
      });
    },

  },
  methods: {
    handleMigrate() {
      this.$api.post('meetings/migrate').then((res)=>{
        this.$Notice.success({title: '同步完成'});
        this.getData();
      });
    },
    handleSelect(key) {
      this.selected = this.items.find((v)=>v.key == key);
    },
    getData() {
      this.loading = true;
      const weeks = '日一二三四五六';
      this.$api.get('meetings?history=1').then((res)=>{
        const items = res.data.data;
        this.res = items;
        const daymap = {};
        items.forEach((v)=>{
          if (v.id) {
            v.date = v.id.slice(0, 8);
            v.duration = v.id[8];
            if (v.duration == 'A') {
              v.duration = 0;
            } else if (v.duration == 'P') {
              v.duration = 1;
            } else {
              return;
            }
            v.room = parseInt(v.id[9]);

            if (!daymap[v.date]) {
              daymap[v.date] = {
                key: v.date,
                name: v.date + ` / 周${weeks[moment(v.date, 'YYYYMMDD').day()]}`,
                icon: 'date',
                durations: [[0, 0, 0, 0], [0, 0, 0, 0]],
              };
            }
            daymap[v.date].durations[v.duration][v.room-1] = v;
          }
          const days = Object.values(daymap);
          days.sort((a, b)=>a.key> b.key?-1:1);
          this.items = days;
          if (this.items.length == 0) {
            this.items = {
              key: moment().format('YYYYMMDD'),

              icon: 'date',
              name: moment().format('YYYYMMDD'),
              durations: [[], []],
            };
          }
          this.selected = this.items[0];
        });
      }).finally(()=>{
        this.loading =false;
      });
    },
  },
};
</script>

<style lang="less">
.pm-panel-flex{
  display: flex;
}
.pm-panel-editing-wrap:hover{
  filter:brightness(1.2);
  cursor: pointer;
}

.pm-panel-selected{
  background:#fbbd2162 !important;
}
</style>
